import Container from 'typedi';
import { BaseAuthenticationFlow, IAuthenticationFlowResult } from '../models';
import { LoggerProvider } from '../../logger';
import { MigrationAuthenticationService } from '../services/migration-authentication.service';
import { IMrGreenMigration } from '../../mr-green-migration/models/interfaces/IMrGreenMigration';
import { AuthenticationFlowType } from '../enums';
import { LoaderManager } from '../../../loaders/LoaderManager';
import { ILogger } from '@sparkware/uc-sdk-core';

export class MigrationAuthenticationFlow extends BaseAuthenticationFlow {
    public type: AuthenticationFlowType = AuthenticationFlowType.Migration;

    private readonly _logger: ILogger;
    private readonly _migrationAuthenticationService: MigrationAuthenticationService;

    private get _mrGreenMigrationPromise(): Promise<IMrGreenMigration> {
        return LoaderManager.Instance.MrGreenMigrationLoader.Instance;
    }

    constructor() {
        super();
        this._logger = Container.get(LoggerProvider).getLogger(
            'MrGreenMigrationAuthenticationFlow',
        );
        this._migrationAuthenticationService = Container.get(MigrationAuthenticationService);
    }

    start = async (): Promise<IAuthenticationFlowResult> => {
        this._logger.debug('start: Executing Mr green migration authentication flow');
        try {
            const isMigrationAutoLoginSuccess = await this._setMigrationAutoLoginSteps();
            return {
                continue: !isMigrationAutoLoginSuccess,
                description: isMigrationAutoLoginSuccess
                    ? 'Logged in with Mr green migration authentication flow.'
                    : 'Continue with other flows since the mr green module will not loaded',
            };
        } catch (err) {
            return {
                continue: true,
                description:
                    'Continue with a fallback since there was an uncaught exception during Mr green migration authentication flow',
            };
        }
    };

    private _setMigrationAutoLoginSteps = async (): Promise<boolean> => {
        const mrGreenMigration = await this._mrGreenMigrationPromise;
        let result: boolean = false;
        if (mrGreenMigration && mrGreenMigration.IsValidForAutoLogin()) {
            const migrationAutoLoginResponse =
                await this._migrationAuthenticationService.migrationAutoLogin({
                    token: mrGreenMigration.Token,
                    businessCorrelationID: mrGreenMigration.BusinessCorrelationId,
                    playerMigratedCookieExist: mrGreenMigration.PlayerMigratedCookieExist,
                });
            if (!migrationAutoLoginResponse.errorResponse) {
                mrGreenMigration.MigrationAutoLoginOcurred = true;
                mrGreenMigration.SetMigrationTokenUsed();
                result = true;
            }
        }
        return result;
    };
}
